import { Injectable, inject } from "@angular/core";
import { DatePipe } from "@angular/common";

import { ApiProvider } from "@providers/common/api.service";
import { AppStorageProvider } from "@providers/common/app-storage.service";

import { manageEndpoints, apiURL } from "@common/constants";

import { detailVINDamage, rateTrip } from "@interfaces/rate-trips/rateTrips.interface";
import { UsuariosInfo } from "@interfaces/ManageUsers/manage-users.interface";


@Injectable({
  providedIn: "root",
})
export class ManageUsersService {
  private api = inject(ApiProvider);
  private storage = inject(AppStorageProvider);
  private datePipe = inject(DatePipe);


  /**
   * @name getManageUsers
   * @desc Metodo que regresa la lista de usuarios
   */

  getManageUsers(requestData: any) {

    return this.api.post(manageEndpoints.getManageUsers, requestData, apiURL);
  }

  /**
   * @name setManageUsers
   * @desc Metodo que regresa el detalle de viajes para calificar
   */

  setManageUsers(requestData: UsuariosInfo) {
    
    return this.api.post(manageEndpoints.setManageUsers, requestData, apiURL);
  }

  /**
   * @name getVinDamageListDetail
   * @desc Metodo que regresa el detalle de viajes para calificar
   */

  getVinDamageListDetail(_requestData: detailVINDamage) {

    // return this.api.post(rateTrips.getVinDanos, requestData, apiURL);
  }

  /**
   * @name postRateTrip
   * @desc Metodo que califica el detalle de viajes 
   */

  postRateTrip(_requestData: rateTrip) {

    // return this.api.post(rateTrips.postRateTrip, requestData, apiURL);
  }


  /**
   * @name getDanos
   * @desc Metodo que califica el detalle de viajes 
   */

  getDanos() {

    // return this.api.post(rateTrips.getDanos, {}, apiURL);
  }

  /**
   * @name getDanos
   * @desc Metodo que califica el detalle de viajes 
   */

  postDanos(_requestData) {

    // return this.api.post(rateTrips.postDanos, requestData, apiURL);
  }

  /**
   * @name postEditedDanos
   * @desc Metodo que guarda los cambios registrados del daño
   */

  postEditedDanos(_requestData) {
    // return this.api.post(rateTrips.postEditedDanos, requestData, apiURL);
  }
}
